/* eslint-disable @typescript-eslint/no-floating-promises */

import { useState } from 'react';
import PortalIdParser from 'PortalIdParser';
import styled from 'styled-components';
import { KOALA, OLAF } from 'HubStyleTokens/colors';
import getIn from 'transmute/getIn';
import { getData } from 'calling-lifecycle-internal/async-flux-utils/operators/getApiProperties';
import { getIsCallIncoming, getShouldShowActiveCallState } from 'calling-internal-common/widget-status/operators/getCallState';
import { getIsTabCall } from 'calling-ui-library/utils/widgetDetailsOperators';
import { getStandaloneConnectionId } from 'calling-cross-tab-library/appData/operators/widgetDetailsOperators';
import { sendCrossTabMessage } from 'calling-cross-tab-library/external/sendCrossTabMessage';
import { createInitiateOutboundCallMessage } from 'calling-lifecycle-messages/deviceEventCreators';
import { getAccountTypeFromPhoneNumber } from 'calling-ui-library/utils/getAccountTypeFromPhoneNumber';
import { getDefaultAssociationsWithCallee } from '../../associations/getDefaultAssociationsWithCallee';
import { getAssociations } from '../../associations/getAssociations';
import { getCallTabUrl } from '../../utils/getCallTabUrl';
import { INITIATE_OUTBOUND_CALL_MESSAGE } from 'calling-lifecycle-messages/deviceEventConstants';
import { getPropertyName, getObjectId, getObjectTypeId, getPhoneNumberProperties, getMetadata } from 'calling-lifecycle-internal/callees/operators/calleesOperators';
// @ts-expect-error not typed
import SearchableCalleeList from 'calling-ui-library/callee-select/components/SearchableCalleeList';
import CallSettingsIcon from 'calling-ui-library/callee-select/components/CallSettingsIcon';
import InboundCallingTracker from 'calling-lifecycle-usage-tracker/inboundCallingTracker';

// @ts-expect-error not typed
import CurrentSettingsInfoActivityCreator from './CurrentSettingsInfoActivityCreator';
import { getCallableObjectAndAssociations } from 'calling-lifecycle-internal/callee-omnibus/operators/calleeOmnibusResultGetters';
import { isCallingFree } from 'calling-internal-common/utils/CallingSalesPro';
import { useWidgetDetails } from 'calling-cross-tab-library/external/useWidgetDetails';
import { getCallStatus } from 'calling-cross-tab-library/appData/operators/widgetDetailsOperators';
import { getIsProviderHubSpot } from 'calling-lifecycle-internal/call-provider/operators/getIsTwilioBasedCallProvider';
import { logCallingError } from 'calling-error-reporting/report/error';
import { logNetworkError } from 'calling-lifecycle-internal/utils/logNetworkError';
import { CallSource } from 'calling-cross-tab-library/constants/CallSource';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CallNotesButtonWrapper = styled.div.withConfig({
  displayName: "CallSettingsNumbersActivityCreator__CallNotesButtonWrapper",
  componentId: "sc-1viepk2-0"
})(["position:sticky;bottom:0;background:", ";border-style:solid;border-width:2px 0 0 0;border-color:", ";"], OLAF, KOALA);
const CalleeSelectDropdownWrapper = styled.div.withConfig({
  displayName: "CallSettingsNumbersActivityCreator__CalleeSelectDropdownWrapper",
  componentId: "sc-1viepk2-1"
})(["max-height:400px;overflow:auto;"]);
const CallSettingsNumbersActivityCreator = props => {
  const {
    widgetDetails
  } = useWidgetDetails();
  const activeConnectionId = getStandaloneConnectionId(widgetDetails);
  const activeCallTabOpen = Boolean(activeConnectionId);
  const crossTabCallStatus = getCallStatus(widgetDetails);
  const [selectedFromNumber, setSelectedFromNumber] = useState(props.defaultFromNumber);
  const openCallTabAndStartOutboundCall = ({
    callableObject,
    toNumber,
    fromNumber,
    accountType,
    associations
  }) => {
    const portalId = PortalIdParser.get();
    const trimmedCallableObject = {
      objectId: getObjectId(callableObject),
      objectTypeId: getObjectTypeId(callableObject),
      crmObjectSubscriptionStatus: getIn(['crmObjectSubscriptionStatus'], callableObject)
    };
    const queryString = `action=${INITIATE_OUTBOUND_CALL_MESSAGE}&callableObject=${JSON.stringify(trimmedCallableObject)}&fromNumber=${fromNumber}&toNumber=${toNumber}&source=${CallSource.CRM}&accountType=${accountType}&associations=${JSON.stringify(associations)}`;
    window.open(getCallTabUrl(portalId, queryString), 'calling-window', 'menubar=no,resizable=yes,scrollbars=no,location=no,width=740,height=750');
  };
  const startOutboundCall = ({
    numberIdentifier,
    callableObject
  }) => {
    const numberPropertyName = getPropertyName(numberIdentifier);
    const phoneNumberProperties = getPhoneNumberProperties(callableObject);
    const propertyToCall = getIn([numberPropertyName], phoneNumberProperties) || null;
    const phoneNumberMetadata = propertyToCall && getMetadata(propertyToCall);
    const toNumber = phoneNumberMetadata.toNumberString;
    let associationsByTypeId = null;
    const objectId = getObjectId(callableObject);
    const objectTypeId = getObjectTypeId(callableObject);
    const fromNumber = getIn(['phoneNumber'], selectedFromNumber);
    const accountType = getAccountTypeFromPhoneNumber(selectedFromNumber);
    if (fromNumber) getAssociations({
      objectTypeId,
      objectId
    }).then(associations => {
      associationsByTypeId = getDefaultAssociationsWithCallee({
        callableObject: {
          objectTypeId,
          objectId
        },
        uasAssociations: associations
      });
    }).catch(networkError => {
      logNetworkError({
        networkError,
        error: new Error('Error fetching associations for outgoing call'),
        tags: {
          requestName: 'query fetchUniversalEngagementAssociations'
        }
      });
    }).finally(() => {
      const associations = associationsByTypeId ? associationsByTypeId.toJS() : {
        [objectTypeId]: [objectId]
      };
      InboundCallingTracker.trackCallTabStartOutboundCall({
        appIdentifier: props.appIdentifier
      });
      if (activeCallTabOpen) {
        sendCrossTabMessage(createInitiateOutboundCallMessage({
          destinationConnectionId: activeConnectionId,
          callableObject: callableObject.toJS(),
          toNumber,
          fromNumber,
          source: CallSource.CRM,
          accountType,
          associations
        })).catch(error => {
          logCallingError({
            error,
            tags: {
              requestName: 'sendCrossTabMessage - initiate outbound call'
            }
          });
        });
      } else {
        openCallTabAndStartOutboundCall({
          callableObject,
          toNumber,
          fromNumber,
          accountType,
          associations
        });
      }
      props.onCallButtonClick();
    });
  };
  const {
    asyncCalleeOmnibus,
    asyncSettingsOmnibus,
    widgetState,
    selectedCallProvider,
    scopes,
    limits
  } = props;
  const calleeOmnibusData = getData(asyncCalleeOmnibus);
  const calleesData = calleeOmnibusData && getCallableObjectAndAssociations(calleeOmnibusData);
  const shouldShowActiveCallState = getShouldShowActiveCallState(widgetState.get('callStatus'));
  const isActiveCallTab = getIsTabCall(widgetDetails);
  const isThirdPartyActive = getIn(['isThirdPartyActive'], widgetState);
  const isFreeCallingAndHS = isCallingFree(scopes) && getIsProviderHubSpot(selectedCallProvider);
  const isCallTabActive = (getShouldShowActiveCallState(crossTabCallStatus) || getIsCallIncoming(crossTabCallStatus)) && isActiveCallTab;
  const disabledTooltipMessage = isFreeCallingAndHS ? 'callSettingsOptions.freeSeatHubSpotCallingBlocked' : isCallTabActive ? 'callSettingsOptions.callActiveOutboundCallBlocked' : null;
  return /*#__PURE__*/_jsxs(CalleeSelectDropdownWrapper, {
    children: [/*#__PURE__*/_jsx(SearchableCalleeList, {
      calleesData: calleesData,
      onSelectToNumber: startOutboundCall,
      disabled: !!disabledTooltipMessage,
      canEdit: false,
      showAddPropertyButton: false,
      CallSettingsIcon: CallSettingsIcon,
      disabledTooltipMessage: disabledTooltipMessage
    }), /*#__PURE__*/_jsx(CallNotesButtonWrapper, {
      children: /*#__PURE__*/_jsx(CurrentSettingsInfoActivityCreator, {
        asyncSettingsOmnibus: asyncSettingsOmnibus,
        disabled: isThirdPartyActive || shouldShowActiveCallState,
        limits: limits,
        scopes: scopes,
        onSelectFromNumber: setSelectedFromNumber,
        selectedCallProvider: selectedCallProvider,
        selectedFromNumber: selectedFromNumber
      })
    })]
  });
};
export default CallSettingsNumbersActivityCreator;